module.exports = __webpack_public_path__ + "media/public/img/sponsors/tripschool-ff3f8e8e7897fe28812f6cd184085926.png";